import React from 'react'

class DefaultBanner extends React.Component {
	render() {
		return <div className="col-xs-9 col-md-9 center-dom bv-plan-container bv-account-settings-billing text-center">
			<div className="" style={{width: "100%", height: "330px", backgroundColor: "#4B5A71"}}>
				<div className="pg-loading-center-outer" style={{paddingTop: "100px"}}>
					<div className="pg-loading-center-middle">
						<h1 className="pg-loading-logo-header">
							<img className="pg-loading-logo" src="/assets/new-logo.png"/>
						</h1>
						<div className="pg-loading-html">
							<p className="pg-loading-message mt-1">The Ultimate WordPress Backup & Security Service</p>
						</div>
					</div>
				</div>
			</div>
			<div className="clearfix" style={{ height: "30px" }}></div>
		</div>
	}
}

export default DefaultBanner
